(() => {
  function initPopup(root) {
    if (root.dataset.tetInitialized === 'true' || typeof root.showModal !== 'function') return;

    const storageKey = root.dataset.tetPopupStorageKey || 'tet-waitlist-popup-state-v2';
    const designMode = root.dataset.tetPopupDesignMode === 'true' || Boolean(window.Shopify?.designMode);
    const delay = Math.max(0, Number(root.dataset.tetPopupDelay) || 0);
    const maxShows = Math.max(1, Number(root.dataset.tetPopupMaxShows) || 1);
    const interval = Math.max(1, Number(root.dataset.tetPopupInterval) || 60) * 1000;
    let memoryState = { count: 0, next: 0 };
    let timer;

    const readState = () => {
      try {
        const saved = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
        return {
          count: Math.max(0, Number(saved.count) || 0),
          next: Math.max(0, Number(saved.next) || 0),
        };
      } catch {
        return memoryState;
      }
    };

    const writeState = (state) => {
      memoryState = state;
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(state));
      } catch {
        return undefined;
      }
    };

    const openPopup = () => {
      if (!root.isConnected || root.open) return;

      if (!designMode) {
        const state = readState();
        if (state.count >= maxShows) return;
        if (state.next > Date.now()) {
          schedule(false);
          return;
        }
        writeState({ count: state.count + 1, next: Date.now() + interval });
      }

      root.showModal();
      root.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    };

    const schedule = (initial) => {
      window.clearTimeout(timer);
      if (!root.isConnected || root.open) return;

      if (designMode) {
        if (initial) timer = window.setTimeout(openPopup, 0);
        return;
      }

      const state = readState();
      if (state.count >= maxShows) return;
      const wait = Math.max(initial ? delay : 0, state.next - Date.now(), 0);
      timer = window.setTimeout(openPopup, wait);
    };

    const closePopup = () => {
      if (root.open) root.close();
      if (!designMode) schedule(false);
    };

    root.dataset.tetInitialized = 'true';
    root.querySelectorAll('[data-tet-popup-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });
    root.addEventListener('click', (event) => {
      if (event.target === root) closePopup();
    });
    root.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });
    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closePopup();
    });

    schedule(true);
  }

  const initAll = () => document.querySelectorAll('[data-tet-waitlist-popup]').forEach(initPopup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
